import { EuiCallOut, EuiFieldSearch, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiSelect } from '@elastic/eui';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import DnSidebarComponent from './PorDn/dnSidebarComponent';
import { FilterProps } from './screen';
import SociedadSidebarComponent from './PorSociedad/sociedadSidebarComponent';

interface sidebarPorops{
    filterConfig:FilterProps;
    estadoUsers?:any;
    translate(word:string):any;
    admExpatriados:Boolean;
}

export const SidebarFacturacionExpatriados = (props:sidebarPorops) =>{

    const {filterConfig,translate,admExpatriados}=props;
    const {filter, setFilter} = filterConfig;
    
    const [tipoFiltro, setTipoFiltro] = useState(filter.tipo);
    const [search, setSearch] = useState('');

    // const optionsTipos:any[] = useMemo(()=>{
    //     let dataOption = [{ value: 'sociedad', text: translate('sociedad')}];
    //     return dataOption;
    //     // return admExpatriados === true ? [dataOption[0],{  value: 'dn', text: translate('dn-sg') }, 
    //     // { value: 'grupoFactura', text: translate('grupoFactura') }, { value: 'usuario', text: translate('usuario') }] : dataOption
    // },[admExpatriados])
    

    //useEffect(()=>{setFilter({tipo:tipoFiltro,selection:''})},[tipoFiltro])

    //const onChangeTipoFiltro = (e:any) => setTipoFiltro(e.target.value)
        
    // const onSelectedItem = (selected:any)=> setFilter({tipo:tipoFiltro,selection:selected})

    const onSelectedItem = (selected:any)=> {setFilter({tipo:tipoFiltro,selection:selected})}

    const getSociedadContent = () => <SociedadSidebarComponent onClick={onSelectedItem} 
    selection={filter.selection} search={search} admExpatriados={admExpatriados}/>
    // const getDnContent = () => <DnSidebarComponent onClickDn={onSelectedItem} selection={filter.selection} search={search}/>
    // const getGrupoFacturacionContent = () => <GrupoFacturaSidebarComponent onClick={onSelectedItem} selection={filter.selection} search={search}/>
    // const getUserContent = () => <UsuarioSidebarComponent onClick={onSelectedItem} selection={filter.selection} estadoUsers={estadoUsers} search={search}/>

    // const getComponentTypeSidebar = useMemo(() =>{
    //     switch (filter.tipo) {
    //         case 'sociedad': return getSociedadContent();
    //         case 'dn': return getDnContent();
    //         case 'grupoFactura': return getGrupoFacturacionContent();
    //         case 'usuario': return getUserContent();
    //         default: return null;
    //     }
    // },[filter,getSociedadContent,getDnContent,getGrupoFacturacionContent,getUserContent])
    const getComponentTypeSidebar = useMemo(() =>{
        switch (filter.tipo) {
            case 'sociedad': return getSociedadContent();
            default: return null;
        }
    },[filter,getSociedadContent])

    return(
        <>
        <EuiFlexItem grow={false}>
            <EuiFlexGroup>
                {/* <EuiFlexItem grow={4}>
                    <EuiSelect
                        id={'tipo-facturacion-filter'}
                        options={optionsTipos}
                        value={tipoFiltro}
                        onChange={(e) => onChangeTipoFiltro(e)}
                        fullWidth
                    />
                </EuiFlexItem> */}
                <EuiFlexItem>
                    <EuiFieldSearch fullWidth placeholder={`${translate('buscar')} ${translate(filter.tipo)} ...`} value={search} isClearable onChange={(e)=> setSearch(e.target.value)}/>
                </EuiFlexItem>
            </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
        <EuiCallOut
            size="s"
            title={`${translate('msg-sidebar-facturacion-expatriados')}.`}
            iconType="iInCircle"
            />
        </EuiFlexItem>
        <EuiFlexItem style={{overflowY:'auto',overflowX:'hidden'}}>
        {getComponentTypeSidebar}
        </EuiFlexItem>
        </>
    )
}